/* Block styles */
import "./block.scss";

/**
 * The core button block will not be using the default styles and will instead
 * be using custom styles.
 */
wp.domReady(function () {
    // Unregister the default styles
    wp.blocks.unregisterBlockStyle("core/button", "fill");
    wp.blocks.unregisterBlockStyle("core/button", "outline");

    // Register new styles
    wp.blocks.registerBlockStyle("core/button", {
        name: "blue",
        label: "Blue",
        isDefault: true,
    });
    wp.blocks.registerBlockStyle("core/button", {
        name: "white",
        label: "White",
    });
});
